import {injectable} from "inversify";
import {ViewController} from "data/types/structure";
import {SECRET_PAGE_KEY} from "data/constants";

@injectable()
export class SecretGateController implements ViewController {
	static CLICK_COUNT = 0;
	static passClicks() {
		SecretGateController.CLICK_COUNT++;
		if(SecretGateController.CLICK_COUNT >= 8) {
			sessionStorage.setItem("isSecretPassed", "true");
			window.location.reload();
		}
	}
	static get IS_SECRET_PASSED() {
		// Checking whether the secret page should be shown.
		const IS_SECRET_ENABLED = Boolean(
			JSON.parse(import.meta.env.VITE_IS_SECRET_ENABLED || "false")
		);

		if (!IS_SECRET_ENABLED) {
			return true;
		}

		// Checking the secret page is already passed.
		const isPassed = Boolean(JSON.parse(sessionStorage.getItem("isSecretPassed") || "false"));

		if (isPassed) {
			return true;
		}

		// Checking the secret page is passed.
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const isEnabled = urlParams.get("secret") === SECRET_PAGE_KEY;

		if (isEnabled) {
			sessionStorage.setItem("isSecretPassed", "true");
			return true;
		}

		return false;
	}
}
